import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { reduxForm } from 'redux-form'
import { Grid, Button } from '@material-ui/core'
import { FORM_HUELLA } from '../../../config/forms'
import logoFingerPrint from '../../../logo/fingerprint_PNG24.png'

// const theme = createTheme({
//   overrides: {
//     MuiCardContent: {
//       root: {
//         padding: 5
//       }
//     }
//   }
// })

class HuellaDialog extends Component {
  componentDidMount () {
    // Llamar a la funcion de BD
    // const { tipo, callback } = this.props
    // this.props.conectar(tipo)
  }

  render () {
    const { perito, nombrePerito, entregador, nombreEntregador, reintentar } = this.props
    return (
      <Grid container direction='column' spacing={2} alignItems='center'>
        <h4>Ingresá tu huella digital</h4>
        <hr />
        <img src={logoFingerPrint} style={{ height: '94px' }} alt='fingerprint' />
        <hr />
        <h6>Toca el sensor de huellas digitales</h6>
        <hr />
        {perito && <h6><b>Perito: {nombrePerito}</b></h6>}
        {entregador && <h6><b>Entregador: {nombreEntregador}</b></h6>}
        {reintentar && <Button color='primary'
          onClick={() => {
            const { tipo, callback } = this.props
            this.props.conectar(tipo, callback)
          }}
        >
            Reintentar
        </Button>}
      </Grid>
    )
  }
}

const mapStateToProps = state => {
  return {
    perito: state.huella.perito,
    nombrePerito: state.huella.nombrePerito,
    entregador: state.huella.entregador,
    nombreEntregador: state.huella.nombreEntregador,
    reintentar: state.huella.reintentar
  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_HUELLA,
  enableReinitialize: true
})(HuellaDialog))
